import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CropperComponent, ImageCropperSetting } from 'angular-cropperjs';

export interface ImageData {
    file: HTMLImageElement;
    name: string;
    type: string;
    width: number;
    height: number;
}
@Component({
    selector: 'app-cropper',
    templateUrl: 'cropper.component.html',
    styleUrls: ['cropper.component.scss'],
})
export class McCropperComponent implements AfterViewInit {
    // cropperSettings: ImageCropperSetting;

    cropperSettings: any;

    scaleX: number = -1;
    scaleY: number = -1;

    @ViewChild('angularCropper', { static: false }) angularCropper: CropperComponent;

    constructor(public dialogRef: MatDialogRef<McCropperComponent>, @Inject(MAT_DIALOG_DATA) public data: ImageData) {
        this.initCropper();
    }

    ngAfterViewInit(): void {
        this.angularCropper.imageUrl = this.data.file.src;
    }

    private initCropper() {
        this.cropperSettings = {
            width: this.data?.width ?? 200,
            height: this.data?.height ?? 200,
            autoCrop: true,
            viewMode: 0,
            autoCropArea: 0.85,
        };
    }

    confirm() {
        const cropedImage = this.angularCropper.cropper.getCroppedCanvas();
        const cleanBase64 = cropedImage.toDataURL().replace(/^data:image\/(png|jpeg|jpg|gif);base64,/, '');
        const cropedFile = this.createFileFromBase64(cleanBase64);
        this.dialogRef.close({ cropedFile, base64: cropedImage.toDataURL() });
    }

    private createFileFromBase64(base64String: string): File {
        const imageBlob = this.dataURItoBlob(base64String);
        const imageFile = new File([imageBlob], this.data.name, { type: this.data.type });
        return imageFile;
    }

    private dataURItoBlob(dataURI) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/png' });
        return blob;
    }

    cropperAction(action: string): void {
        switch (action) {
            case 'zoom-in':
                this.angularCropper.cropper.zoom(0.1);
                break;

            case 'zoom-out':
                this.angularCropper.cropper.zoom(-0.1);
                break;

            case 'move-left':
                this.angularCropper.cropper.move(-10, 0);
                break;

            case 'move-right':
                this.angularCropper.cropper.move(10, 0);
                break;

            case 'move-up':
                this.angularCropper.cropper.move(0, -10);
                break;

            case 'move-down':
                this.angularCropper.cropper.move(0, 10);
                break;

            case 'rotate-left':
                this.angularCropper.cropper.scaleX(this.scaleX);
                this.scaleX = this.scaleX * -1;
                break;

            case 'rotate-right':
                this.angularCropper.cropper.scaleY(this.scaleY);
                this.scaleY = this.scaleY * -1;
                break;

            case 'flip-y':
                this.angularCropper.cropper.rotate(-45);
                break;

            case 'flip-x':
                this.angularCropper.cropper.rotate(45);
                break;

            case 'reset':
                this.angularCropper.cropper.reset();
                this.scaleX = -1;
                this.scaleY = -1;
                break;
        }
    }
}
